var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6105 0.921278C16.0994 0.924113 16.494 1.34657 16.494 1.86542L16.5002 6.54363C16.5002 7.06532 16.1029 7.48966 15.6123 7.48966H15.6114C15.1208 7.48966 14.7226 7.06721 14.7226 6.54552L14.7181 4.10529L7.35145 11.9382C7.17813 12.1234 6.95058 12.2151 6.72304 12.2151C6.4955 12.2151 6.26796 12.1234 6.09464 11.9382C5.7471 11.5696 5.7471 10.9714 6.09464 10.6018L13.4355 2.79728L11.1619 2.76421C10.6704 2.76137 10.2748 2.33513 10.2784 1.81344C10.2815 1.35422 10.5913 0.97319 11.0005 0.890615L15.6105 0.921278ZM11.0005 0.890615C11.0545 0.879723 11.1103 0.874023 11.1672 0.874023H8.50605L11.0005 0.890615ZM14.7214 11.2308C14.7214 10.7092 15.1196 10.2858 15.6102 10.2858C16.1009 10.2858 16.499 10.7092 16.499 11.2308V15.4279C16.499 16.7832 15.4618 17.8861 14.1881 17.8861H2.81097C1.53727 17.8861 0.5 16.7832 0.5 15.4279V3.33171C0.5 1.97645 1.53727 0.874471 2.81097 0.874471H6.75912C7.24976 0.874471 7.64796 1.29693 7.64796 1.81956C7.64796 2.34125 7.24976 2.76465 6.75912 2.76465H2.81097C2.51677 2.76465 2.27767 3.01888 2.27767 3.33171V15.4279C2.27767 15.7408 2.51677 15.9959 2.81097 15.9959H14.1881C14.4823 15.9959 14.7214 15.7408 14.7214 15.4279V11.2308Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a823d178af86ea70b94d74d0e775971e.svg";
export { ForwardRef as ReactComponent };